import { render, staticRenderFns } from "./ExportProjectAsDocxDialog.vue?vue&type=template&id=6d2db7cc"
import script from "./ExportProjectAsDocxDialog.vue?vue&type=script&lang=ts"
export * from "./ExportProjectAsDocxDialog.vue?vue&type=script&lang=ts"
import style0 from "./ExportProjectAsDocxDialog.vue?vue&type=style&index=0&id=6d2db7cc&prod&lang=scss&module=true"
import style1 from "./ExportProjectAsDocxDialog.vue?vue&type=style&index=1&id=6d2db7cc&prod&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports